import React from 'react'

import './ProductBenefits.scss';

const ProductBenefits = ({ benefitsProduct }) => {
  const benefits = benefitsProduct.split('|');
  return (
    <section className="product-benefits" id="product-benefits-section">
      {benefits.map((benefit, index) => (
        <span key={`${index + 1}`} className="benefit">
          {benefit}
          {index < benefits.length - 1 && <span className="separator">•</span>}
        </span>
      ))}
    </section>
  );
};

export default ProductBenefits;